const roles = [
  {
    id: 1,
    name: "Суперадмин"
  },
  {
    id: 2,
    name: "Менеджер"
  },
  {
    id: 3,
    name: "Водитель/санитар"
  }
]

export default function getRole(role_id: number) {
  return roles.find(item => item.id === role_id)
}